import { modifier } from 'ember-modifier';

export default modifier(
  (element: Element) => {
    function handleClickEvent(event: Event) {
      if (
        event.target &&
        event.target instanceof Element &&
        event.target.parentElement &&
        event.target.parentElement.nextElementSibling
      ) {
        let element = event.target.parentElement.nextElementSibling;
        if (element && element.classList.contains('toggle')) {
          if (element.classList.contains('hide')) {
            element.classList.remove('hide');
          } else {
            element.classList.add('hide');
          }
        }
      }
    }

    let toggles = element.querySelectorAll('.helptext-section_header button');
    for (const toggle of toggles) {
      toggle.addEventListener('click', handleClickEvent);
    }

    return () => {
      let toggles = element.querySelectorAll('.helptext-section_header button');
      for (const toggle of toggles) {
        toggle.removeEventListener('click', handleClickEvent);
      }
    };
  },
  { eager: false },
);
